import builder from '../builder';
import BookOpenText from '../../streamline-icons/bold/book-open-text.svg';

export default builder('IconBookOpenTextBold', BookOpenText);
